<template>
  <div>
    <v-sheet height="64" class="d-flex align-center rounded-t">
      <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn icon class="ma-2" @click="$refs.calendar.next()">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-toolbar-title v-if="$refs.calendar">{{
        $refs.calendar.title
      }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday"
        >Today</v-btn
      >
      <v-menu bottom right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
            <span>{{ typeToLabel[type] }}</span>
            <v-icon right>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="type = 'month'">
            <v-list-item-title>Month</v-list-item-title>
          </v-list-item>
          <v-list-item @click="type = 'week'">
            <v-list-item-title>Week</v-list-item-title>
          </v-list-item>
          <v-list-item @click="type = 'day'">
            <v-list-item-title>Day</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-checkbox
        v-if="type !== 'day'"
        v-model="weekend"
        label="주말 표시"
        class="mx-3"
      ></v-checkbox>
    </v-sheet>
    <v-sheet height="800" class="pa-3">
      <v-calendar
        ref="calendar"
        v-model="value"
        color="primary"
        :weekdays="weekday"
        :type="type"
        :events="events"
        :event-overlap-mode="mode"
        :event-overlap-threshold="30"
        :event-color="getEventColor"
        :event-ripple="false"
        @change="getEvents"
        @click:event="showEvent"
        @click:more="viewDay"
        @click:date="viewDay"
        @mousedown.stop.native="checkMore"
        @mousedown:event="startDrag"
        @mousedown:time="startTime"
        @mousemove:time="mouseMove"
        @mouseup:time="endDrag"
        @mousedown:day="startTime"
        @mousemove:day="mouseMove"
        @mouseup:day="endDrag"
        @mouseup.stop.native="addEvent"
        @mouseleave.native="cancelDrag"
      >
        <template #event="{ event, timed, eventSummary }">
          <div class="v-event-draggable" v-html="eventSummary()"></div>
          <div
            v-if="timed"
            class="v-event-drag-bottom"
            @mousedown.stop="extendTime(event)"
          ></div>
          <!-- <div
            v-else
            class="v-event-drag-right"
            @mousedown.stop="extendTime(event)"
          ></div>-->
        </template>
      </v-calendar>
      <v-menu
        v-model="selectedOpen"
        :close-on-content-click="false"
        :position-x="selectedPosition.x"
        :position-y="selectedPosition.y"
      >
        <v-card color="grey lighten-4" min-width="300px" flat>
          <v-toolbar height="50" :color="selectedEvent.color" dark>
            <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="showCreateModal(selectedEvent)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon @click="removeEvent">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <p v-if="selectedEvent.prjNm">
              <span>프로젝트 :&nbsp;</span>
              <span class="grey--text text--darken-2">{{
                selectedEvent.prjNm
              }}</span>
            </p>
            <p>
              <span>일정 :&nbsp;</span>
              <span class="grey--text text--darken-2">
                {{ selectedEvent.startDt }}
                {{ selectedEvent.startTm }}
                ~
                {{ selectedEvent.endDt }}
                {{ selectedEvent.endTm }}
              </span>
            </p>
            <p v-if="selectedEvent.empList">
              <span>참여직원 :&nbsp;</span>
              <template v-for="emp in selectedEvent.empList">
                <span :key="emp.empNo" class="grey--text text--darken-2"
                  >{{ emp.empNm }}&nbsp;</span
                >
              </template>
            </p>
            <p v-if="selectedEvent.planText" class="grey--text text--darken-2">
              {{ selectedEvent.planText }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="secondary" @click="selectedOpen = false"
              >취소</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-menu>
      <v-row justify="center">
        <v-dialog v-model="dialog" max-width="500">
          <schedule-create
            :isShow="dialog"
            @hideModal="dialog = false"
            @showAlert="showAlert"
          ></schedule-create>
        </v-dialog>
      </v-row>
    </v-sheet>
    <v-snackbar v-model="snackbar.show" timeout="1000">
      {{ snackbar.message }}
      <!-- <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">Close</v-btn>
      </template>-->
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import { listPlan, listPlanDetail, modiPlan, delPlan } from "@/api/plan";
import ScheduleCreate from "@/components/calendar/ScheduleCreate";

export default {
  data: () => ({
    dialog: false,
    isMore: false,
    snackbar: {
      show: false,
      message: "",
    },
    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
    },
    mode: "stack",
    weekend: false,
    value: "",
    events: [],
    selectedEvent: {},
    selectedPosition: {},
    selectedOpen: false,
    dragEvent: null,
    dragStart: null,
    dragged: false,
    createEvent: null,
    createStart: null,
    extendOriginal: null,
  }),
  components: { ScheduleCreate },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.getEvents();
      }
    },
  },
  computed: {
    weekday() {
      if (this.weekend) {
        // 주말 포함
        return [0, 1, 2, 3, 4, 5, 6];
      } else {
        // 주말 제외
        return [1, 2, 3, 4, 5];
      }
    },
  },
  mounted() {
    this.$refs.calendar.checkChange();
  },
  methods: {
    ...mapActions("schedule", ["SELECT_DATE"]),
    checkMore(e) {
      if (e.target.className.indexOf("more") > 0) {
        this.isMore = true;
      }
    },
    viewDay({ date }) {
      // more, clickDay
      this.value = date;
      this.type = "day";
    },
    setToday() {
      this.value = "";
    },
    showAlert(msg) {
      this.snackbar.show = true;
      this.snackbar.message = msg;
    },
    showCreateModal(createEvent) {
      // 상세보기 클릭시 null이므로 return false;
      if (!createEvent) return false;

      // 등록, 수정 팝업 열기, 팝업에 데이터 전달
      const startDt = moment(createEvent.start).format("YYYY-MM-DD");
      const startTm = moment(createEvent.start).format("HH:mm");
      const endDt = moment(createEvent.end).format("YYYY-MM-DD");
      const endTm = moment(createEvent.end).format("HH:mm");

      // 수정일 경우 empList의 empNo만 전달
      const empList = !createEvent.empList
        ? []
        : createEvent.empList.map(v => {
            return v.empNo;
          });

      this.SELECT_DATE({
        ...createEvent,
        empList,
        startDt,
        endDt,
        startTm,
        endTm,
      });
      this.selectedOpen = false;
      this.dialog = true;
    },
    addEvent() {
      // drag 이벤트 중에는 상세보기 보이지 않음
      const createEvent = this.createEvent;
      const beforeType = this.type;

      // 상세보기, drag이벤트 중 등록 팝업 열지 않음
      if (this.selectedOpen || this.dragged) return false;

      // 상세보기 클릭 시 팝업을 동시에 열지 않도록 처리. addEvent함수가 먼저 실행되므로 timeout 설정
      setTimeout(() => {
        if (!this.selectedOpen && beforeType === this.type) {
          this.showCreateModal(createEvent);
        }
      }, 100);
    },
    async removeEvent() {
      // 삭제
      try {
        const planNo = this.selectedEvent.planNo;
        const { data } = await delPlan(planNo);

        if (data.ret > 0) {
          this.selectedOpen = false;
          this.selectedEvent = {};
          this.getEvents();

          this.showAlert("삭제되었습니다.");
        } else {
          this.showAlert("삭제 실패");
        }
      } catch (err) {
        console.error(err);
      }
    },
    async showEvent({ nativeEvent, event }) {
      // drag 이벤트 중에는 상세보기 보이지 않음
      if (this.dragged) return false;

      try {
        // 상세보기
        const { data } = await listPlanDetail(event.planNo);
        const planData = data.plan;

        const open = () => {
          this.selectedEvent = { ...event, ...planData };
          this.selectedPosition = {
            x: nativeEvent.clientX,
            y: nativeEvent.clientY,
          };
          // 달력 넘어가면 위치를 인식하지 못하므로 timeout
          setTimeout(() => {
            this.selectedOpen = true;
            this.dragged = false;
          }, 10);
        };

        if (this.selectedOpen) {
          this.selectedOpen = false;
          setTimeout(open, 10);
        } else {
          open();
        }

        nativeEvent.stopPropagation();
      } catch (err) {
        console.error(err);
      }
    },
    async modiEvent(dragEvent) {
      // 일정 변경 수정
      const {
        planNo,
        empList,
        planTitle,
        planText,
        planTyNo,
        start,
        end,
      } = dragEvent;

      if (!planNo) return false;

      try {
        const newEmpList = !empList
          ? []
          : empList.map(v => {
              return { empNm: v.empNm, empNo: v.empNo };
            });

        const formData = {
          planTitle,
          planText,
          planTyNo,
          empList: newEmpList,
          planStDt: moment(start).format("YYYYMMDD"),
          planStTm: moment(start).format("hhmm"),
          planEdDt: moment(end).format("YYYYMMDD"),
          planEdTm: moment(end).format("hhmm"),
          emailSendYn: "N",
        };

        const { data } = await modiPlan(planNo, formData);

        if (data.ret < 0) {
          this.showAlert("저장 실패");
        } else {
          this.showAlert("저장되었습니다.");
        }
      } catch (err) {
        console.error(err);
      }
    },
    startDrag({ event }) {
      if (event) {
        this.dragEvent = event;
        this.dragTime = null;
        this.extendOriginal = null;

        setTimeout(() => {
          if (!this.selectedOpen) {
            this.dragged = true;
          }
        }, 150);
      }
    },
    startTime(tms) {
      setTimeout(() => {
        if (this.isMore) return false;
        if (this.selectedOpen) return false;

        const mouse = this.toTime(tms);

        if (this.dragEvent && this.dragTime === null) {
          const start = this.dragEvent.start;

          this.dragTime = mouse - start;
        } else {
          const workingTime = 9 * 60 * 60 * 1000;
          // this.createStart = this.roundTime(mouse);
          this.createStart = mouse;

          this.createEvent = {
            name: `새로운 이벤트 #${this.events.length + 1}`,
            color: "#757575",
            start: this.createStart,
            end: this.createStart + workingTime,
            timed: true,
          };

          this.events.push(this.createEvent);
        }
      }, 10);
    },
    mouseMove(tms) {
      const mouse = this.toTime(tms);

      if (this.dragEvent && this.dragTime !== null) {
        // 스케줄 drag 이동
        const start = this.dragEvent.start;
        const end = this.dragEvent.end;
        const duration = end - start;
        const newStartTime = mouse - this.dragTime;
        // const newStart = this.roundTime(newStartTime);
        const newEnd = newStartTime + duration;

        this.dragEvent.start = newStartTime;
        this.dragEvent.end = newEnd;
      } else if (this.createEvent && this.createStart !== null) {
        // drag 하여 스케줄 생성
        // const mouseRounded = this.roundTime(mouse, false);
        const workingTime = 9 * 60 * 60 * 1000;
        const min = Math.min(mouse, this.createStart);
        const max = Math.max(mouse, this.createStart);

        this.createEvent.start = min;
        this.createEvent.end = max + workingTime;
      }
    },
    endDrag() {
      // 스케줄 드래그 이동시 날짜 수정 적용
      const dragEvent = this.dragEvent || this.createEvent;

      this.createStart = null;
      this.dragTime = null;
      this.dragEvent = null;
      this.extendOriginal = null;

      setTimeout(() => {
        this.dragged = false;
        this.createEvent = null;
      }, 10);

      // 등록이 아닌 경우, 상세보기가 열려있지 않는 경우 modiEvent 실행
      if (!this.dragged) return false;
      setTimeout(() => {
        if (!this.selectedOpen) {
          // 상세보기가 아닌 경우 modiEvent 실행
          this.modiEvent(dragEvent);
        }
      }, 200);
    },
    cancelDrag() {
      if (this.createEvent) {
        if (this.extendOriginal) {
          this.createEvent.end = this.extendOriginal;
        } else {
          const i = this.events.indexOf(this.createEvent);
          if (i !== -1) {
            this.events.splice(i, 1);
          }
        }
      }

      this.createEvent = null;
      this.createStart = null;
      this.dragTime = null;
      this.dragEvent = null;
      this.dragged = false;
    },
    extendTime(event) {
      this.createEvent = event;
      this.createStart = event.start;
      this.extendOriginal = event.end;
      this.dragged = true;

      this.modiEvent(event);
    },
    roundTime(time, down = true) {
      // 시간을 반올림..?
      const roundTo = 15; // minutes
      const roundDownTime = roundTo * 60 * 1000;

      return down
        ? time - (time % roundDownTime)
        : time + (roundDownTime - (time % roundDownTime));
    },
    toTime(tms) {
      // 달력 날짜 정보를 받아서 millisecond로 변경
      return new Date(
        tms.year,
        tms.month - 1,
        tms.day,
        tms.hour === 0 ? 10 : tms.hour,
        tms.minute === 0 ? 0 : tms.minute,
      ).getTime();
    },
    getEventColor(event) {
      return event.color;
    },
    async getEvents() {
      this.isMore = false;

      try {
        const { data } = await listPlan();

        if (data.ret < 0) return false;
        if (!data.list) return false;

        const newList = data.list.map(item => {
          const list = {};
          const startDate = moment(item.planStDt).format("YYYY-MM-DD");
          const startTime = moment(item.planStTm, "hmm").format("HH:mm");
          const endDate = moment(item.planEdDt).format("YYYY-MM-DD");
          const endTime = moment(item.planEdTm, "hmm").format("HH:mm");
          const start = new Date(`${startDate} ${startTime}`);
          const end = new Date(`${endDate} ${endTime}`);

          // 휴가일 경우 사원 이름 표시
          let name;
          if (item.planTyNo === 404 && item.empList.length) {
            name = `[${item.planTyNm}] ${item.empList[0].empNm}`;
          } else {
            name = `[${item.planTyNm}] ${item.planTitle}`;
          }

          list.planNo = item.planNo;
          list.planTyNo = item.planTyNo;
          list.prjNo = item.prjNo;
          list.planTitle = item.planTitle;
          list.empList = item.empList;
          list.planText = item.planText;
          list.startDt = startDate;
          list.startTm = startTime;
          list.endDt = endDate;
          list.endTm = endTime;
          list.etc = item.note;

          // calendar default setting
          list.name = name;
          list.start = start.getTime();
          list.end = end.getTime();
          list.color = item.planColHexaCd;
          list.timed = true;

          return list;
        });

        this.events = newList;
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.v-event-draggable {
  padding-left: 6px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-right {
  position: absolute;
  top: 0;
  right: 0;
  width: 10px;
  height: 100%;
  cursor: ew-resize;

  &::after {
    display: none;
    width: 5px;
    height: 12px;
    margin: 4px 4px 0 0;
    border-left: 1px solid white;
    border-right: 1px solid white;
    opacity: 0.8;
    content: "";
  }

  &:hover::after {
    display: block;
  }
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    width: 16px;
    height: 4px;
    margin-left: -8px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    opacity: 0.8;
    content: "";
  }

  &:hover::after {
    display: block;
  }
}
</style>
